import axios from '../customize/axiosReg';
import axiosAuto from '../customize/axiosAuto';

const API_BASE_URL = process.env.REACT_APP_MAIN_API_URL || '';

export const fetchUID = async () => {
  return axios.get(`${API_BASE_URL}/uid`);
};

export const fetchLogs = async () => {
  return axios.get(`${API_BASE_URL}/logs`);
};

export const handleSaveInfoWhenIn = (data) => {
  try {
    return axios.post('/save-detail/', data)
  } catch (error) {
    console.log('error at handleSaveInfoWhenIn: ', error);

  }
}




export const handleCheckInfoWhenOut = (data) => {
  try {
    return axios.post('/check-out/', data)
  } catch (error) {
    console.log('error at handleSaveInfoWhenIn: ', error);
  }
}

export const recognizePlate = async (data) => {
  try {
    console.log('FormData contents:');
    for (let [key, value] of data.entries()) {
      if (value instanceof Blob) {
        console.log(`  ${key}: Blob(${value.size} bytes, ${value.type})`);
      } else {
        console.log(`  ${key}:`, value);
      }
    }

    return await axios.post('/rfid/recognize-plate', data, {
      // headers: {
      //   "Content-Type": "multipart/form-data"
      // }
    });
  } catch (error) {
    console.error('Lỗi tại recognizePlate:', error);
  }
};

export const recognizePlateAutomatic = async (data) => {
  try {
    return await axiosAuto.post('/recognize-plate', data);
  } catch (error) {
    console.error('Lỗi tại recognizePlateAutomatic:', error);
    return error?.response?.data || {
      EC: -1,
      EM: error?.message || 'Auto Detect backend connection failed',
      DT: []
    };
  }
};
